import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { base_url } from '../../Api/Api';
import { Loader } from '../../Global/Loader';

import Header from '../../Global/Header';
import ItemCurrent from './itemCurrentLottery';
import ItemArchive from './itemArchiveLottery';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
            className="tab-style"
        >
            <Box>
                {children}
            </Box>
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
}));

const MyLottery = (props) => {

    const [state, setState] = useState({
        data: null, // api data
        archiveData: null,
        loader: true
    })
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    useEffect(() => {
        // my_lotteries_active    // my_lotteries_archive


        base_url.get(`my_lotteries_active`)
            .then(response => {
                console.log(response.data.lotteries)
                base_url.get(`my_lotteries_archive`)
                    .then(responseArchive => {
                        console.log(responseArchive.data.lotteries)
                        setState({
                            ...state,
                            data: response.data.lotteries.reverse(),
                            archiveData: responseArchive.data.lotteries.reverse(),
                            loader: false
                        })
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            console.log(error)
                            if (error.response.status == 401) {
                                localStorage.clear()
                                props.history.push(`/Entrance`)
                                window.location.reload()
                            }
                        }
                    })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <div className="profile-lottery">
            <Loader
                active={state.loader} />
            <Header
                innerPage={true}
                title={'قرعه کشی های من'} />

            <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    <Tab label="جاری" {...a11yProps(0)} />
                    <Tab label="آرشیو" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === 'ltr' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel className="tab-style" value={value} index={0} dir={theme.direction}>
                    {state.data == null ?
                        <span className="no-info"> <i className="icon-present-box-11"></i> قرعه کشی وجود ندارد</span>
                        :
                        state.data.length == 0 ?
                            <span className="no-info"> <i className="icon-present-box-11"></i> قرعه کشی وجود ندارد</span>
                            :
                            state.data.map(info =>
                                <ItemCurrent
                                    data={info} />
                            )
                    }
                </TabPanel>
                <TabPanel className="tab-style" value={value} index={1} dir={theme.direction}>
                    {state.archiveData == null ?
                        <span className="no-info"> <i className="icon-present-box-11"></i> قرعه کشی وجود ندارد</span>
                        :
                        state.archiveData.length == 0 ?
                            <span className="no-info"> <i className="icon-present-box-11"></i> قرعه کشی وجود ندارد</span>
                            :
                            state.archiveData.map(info =>
                                <ItemArchive
                                    data={info} />
                            )
                    }
                </TabPanel>
            </SwipeableViews>

        </div>
    );
}

export default MyLottery;